import React, { FC, useMemo } from 'react';
import { Image } from '@design-system/image';

import { DecorationProps } from '../models';

const DecorationImage: FC<DecorationProps> = ({
  image,
  size,
  top = 'auto',
  left = 'auto',
  right = 'auto',
  bottom = 'auto',
  dur = 3.5,
  delay = 0,
  zIndex = 2,
}) => {
  const randomPhase = useMemo(() => Math.random() * 360, []);
  const randomX = useMemo(() => 6 + Math.random() * 6, []);
  const randomY = useMemo(() => 8 + Math.random() * 8, []);
  const transformOrigin = useMemo(
    () => `${50 + Math.random() * 10}% ${50 + Math.random() * 10}%`,
    []
  );

  return (
    <Image
      src={image}
      role="presentation"
      className="products-slider-bubbles-item__decoration-img"
      style={
        {
          position: 'absolute',
          top,
          left,
          bottom,
          right,
          width: `${size}px`,
          height: 'auto',
          animation: `floatXY ${dur}s ease-in-out ${delay}s infinite`,
          filter: 'drop-shadow(0 8px 10px rgba(0,0,0,.25))',
          pointerEvents: 'none',
          zIndex,
          transformOrigin,
          '--phase': `${randomPhase}deg`,
          '--ampX': `${randomX}px`,
          '--ampY': `${randomY}px`,
        } as React.CSSProperties
      }
    />
  );
};

export default DecorationImage;
